import { render, staticRenderFns } from "./MultiICD10Field.vue?vue&type=template&id=5865de30"
import script from "./MultiICD10Field.vue?vue&type=script&lang=js"
export * from "./MultiICD10Field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports